import React, { useState } from 'react';
import styled from 'styled-components';

const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const TooltipIcon = styled.span`
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background: ${props => props.theme.colors.blue};
  color: ${props => props.theme.colors.white};
  border-radius: 50%;
  font-size: 0.75rem;
  cursor: help;
  margin-left: 0.5rem;
  vertical-align: middle;
`;

const TooltipBox = styled.div<{ visible: boolean }>`
  visibility: ${props => props.visible ? 'visible' : 'hidden'};
  opacity: ${props => props.visible ? 1 : 0};
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${props => props.theme.colors.darkBlue};
  color: ${props => props.theme.colors.white};
  padding: ${props => props.theme.spacing.sm};
  border-radius: ${props => props.theme.borderRadius.md};
  font-size: 0.85rem;
  white-space: normal;
  width: 250px;
  z-index: 1000;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  box-shadow: ${props => props.theme.shadows.lg};

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: ${props => props.theme.colors.darkBlue} transparent transparent transparent;
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    width: 200px;
  }
`;

interface TooltipProps {
  text: string;
}

const Tooltip: React.FC<TooltipProps> = ({ text }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <TooltipContainer
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      <TooltipIcon>?</TooltipIcon>
      <TooltipBox visible={isVisible}>
        {text}
      </TooltipBox>
    </TooltipContainer>
  );
};

export default Tooltip;
